import Util from '@/utils/util'
import Axs from '@/utils/axs'
import {defineStore} from 'pinia'
import storeInfoFun from '@/info.js'
import { ElMessage } from "element-plus";

let storeFunc = defineStore("zhsq/merchants",{
    state:()=>{
        return {
      

            OrganizationTypeEnum:[
                {
                    id: 0,
                    label: "个人经营"
                },
                {
                    id: 1,
                    label: "个体户"
                },
                {
                    id: 2,
                    label: "私营企业"
                },
                {
                    id: 3,
                    label: "事业单位"
                },
                {
                    id: 4,
                    label: "政府机构"
                },
                {
                    id: 5,
                    label: "国营企业"
                },
                {
                    id: 6,
                    label: "外资企业"
                },
                {
                    id: 7,
                    label: "其他组织"
                },
            ],
 


            detailsTypeEnum:[
                {
                    id: 0,
                    label: "文本"
                },
                {
                    id: 1,
                    label: "图片"
                },
                {
                    id: 2,
                    label: "位置"
                },
       
            ],

            StatusEnum:[
                {
                    id: 0,
                    label: "未营业"
                },
                {
                    id: 1,
                    label: "营业中"
                },
            ],

            huifuApplyStatusEnum:[
                {
                    id: 'Y',
                    label: "审核通过"
                },
                {
                    id: 'N',
                    label: "审核拒绝"
                },
                {
                    id: 'F',
                    label: "系统失败"
                },
                {
                    id: 'P',
                    label: "审核中"
                },
        
            ],
        }
    },
    actions:{
        getTempDataForSelect(callback,failback, forceload)
        {
            //debugger;
             if(!forceload &&  !Util.isEmpty(this.tempDataForSelect))
             {
                 if(callback)
                 {
                     callback(this.tempDataForSelect)
                 }
                 return;
             }

             let storeInfo = storeInfoFun();
             let url = storeInfo.linkUrl + "api/zhsq/merchants/loadAll";
         
             Axs.get(url, {}, null, (req) => {
                 //   console.log(url + "   Data====>",req.data)
          
                 let data = req.data;
                 this.tempDataForSelect = []
                 data.forEach(element => {
                     let selectObj = {
                         id:element.id,
                         label:element.name,
                         value:element,
                         disabled:false
                     }
                     this.tempDataForSelect.push(selectObj);
                 });
                 if(callback)
                 {
                     callback(this.tempDataForSelect)
                 }
             }, (err) => {
                
                 if(failback)
                 failback(err)
             },undefined,true)
        },
        clearTempDataForSelect()
        {
             this.tempDataForSelect = null;
        },
 
         getTempDataByID(id) {
            //  if (Util.isEmpty(this.tempDataForSelect))
            //  {
            //      this.getTempDataForSelect()
            //  }
             if (Util.isEmpty(this.tempDataForSelect))
             {
                 return null;
             }
             let find = null
             this.tempDataForSelect.forEach(element => {
                if (Number(element.id) == Number(id))
                     find = element;
             });
             return find;
         },
         
         async loadDataByIDAsync(id) {
            // console.log("loadDataByIDAsync==>??????????????id=",id);
             if(Util.isEmpty(id))
             {
                return null
             }
             let storeInfo = storeInfoFun();
             let url = storeInfo.linkUrl + "api/zhsq/merchants/load";
             let ret =  await Axs.getAsync(url, {id})
             let data = ret.data;
             if(Util.isEmpty(data))
             {
                 return new Promise((resolve,reject)=> {
                     resolve(null);
                 });
             }
             return new Promise((resolve,reject)=> {
                 let retData = null
                 if(data.length > 0)
                     retData = data[0]
                 resolve(retData);
             });
 
          }
    },
    getters:{
        //计算属性，只读属性
    },
    persist: false
})

 //组合式写法 mixin混合写法
// let storeFunc = defineStore("user",()=>{
//     //组合式写法
//     let p = ref("xx");
//     return {
//         p
//     }
// })


export default storeFunc